import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import {
	MatCardModule,
	MatInputModule,
	MatTableModule,
	MatButtonModule,
	MatSelectModule,
	MatExpansionModule,
	MatFormFieldModule,
	MatProgressSpinnerModule,
	MatCheckboxModule,
	MatTooltipModule,
	MatDividerModule,
	MatAutocompleteModule,
	MatDialogModule
} from "@angular/material"
import { RouterModule } from "@angular/router"
import { NgbModule, NgbModalConfig, NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { TranslateModule } from "@ngx-translate/core"
import { Ng2PageScrollModule } from "ng2-page-scroll"
import { NgxFileDropModule } from "ngx-file-drop"
import { MapService } from "src/app/services/map.service"
import { ModalErrorComponent } from "./modals/modal-error/modal-error.component"
import { SearchPlaceComponent } from "./address/search-place/search-place.component"
import { GMapButtonComponent } from "./map/gmap-button/gmap-button.component"
import { GMapComponent } from "./map/gmap/gmap.component"
import { ModalCoverageErrorComponent } from "./modals/modal-coverage-error/modal-coverage-error.component"
import { ModalMultiBuildingComponent } from "./modals/modal-multi-building/modal-multi-building.component"
import { ModalLoaderComponent } from "./modals/modal-loader/modal-loader.component"

@NgModule({
	declarations: [
		ModalErrorComponent,
		SearchPlaceComponent,
		GMapComponent,
		GMapButtonComponent,
		ModalCoverageErrorComponent,
		ModalMultiBuildingComponent,
		ModalLoaderComponent
	],
	imports: [
		RouterModule,
		CommonModule,
		FormsModule,
		MatCardModule,
		MatInputModule,
		MatTableModule,
		MatButtonModule,
		MatSelectModule,
		MatExpansionModule,
		MatSelectModule,
		Ng2PageScrollModule.forRoot(),
		NgbModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		MatCheckboxModule,
		TranslateModule,
		MatTooltipModule,
		MatDividerModule,
		MatAutocompleteModule,
		ReactiveFormsModule,
		NgxFileDropModule,
		MatDialogModule
	],
	exports: [
		RouterModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatCheckboxModule,
		ModalErrorComponent,
		SearchPlaceComponent,
		GMapComponent,
		ModalCoverageErrorComponent,
		ModalMultiBuildingComponent,
		ModalLoaderComponent
	],
	providers: [MapService, NgbModalConfig, NgbModal]
})
export class PartialsModule {}
